module.exports = "https://images.shiksha.ws/saassets/media/instagram.f106ab85.svg";